export interface AuditItem {
  id: string;
  action: string;
  performedByRole: string;
  performedById?: string;
  timestamp: string;
  metadata?: Record<string, unknown>;
}

export class AuditTrailDrawer {
  private element: HTMLElement;
  private logs: AuditItem[] = [];

  constructor(private readonly apiBaseUrl: string) {
    this.element = document.createElement('div');
    this.element.style.display = 'flex';
    this.element.style.flexDirection = 'column';
    this.element.style.gap = '8px';
    this.element.style.fontSize = '0.8rem';
    this.element.style.fontFamily = 'var(--font-mono)';
  }

  public async fetchLogs(sessionId: string): Promise<void> {
    try {
      const res = await fetch(`${this.apiBaseUrl}/api/v1/sessions/${sessionId}/audit`);
      const json = (await res.json()) as { success: boolean; data?: AuditItem[] };
      if (json.success && json.data) {
        this.logs = json.data;
        this.render();
      }
    } catch (e) {
      console.warn('[AUDIT] Error consultando logs:', e);
    }
  }

  public addLiveLog(action: string, role: string, metadata?: Record<string, unknown>): void {
    this.logs.unshift({
      id: `live_${Date.now()}`,
      action,
      performedByRole: role,
      timestamp: new Date().toLocaleTimeString(),
      metadata
    });
    this.render();
  }

  private render(): void {
    if (this.logs.length === 0) {
      this.element.innerHTML = `
        <div style="color:var(--text-dim); text-align:center; padding:16px;">
          Sin eventos registrados aún.
        </div>
      `;
      return;
    }

    this.element.innerHTML = this.logs
      .map(
        (log) => `
        <div style="background:rgba(255,255,255,0.03); border:1px solid var(--border-dim); border-radius:6px; padding:6px 10px; display:flex; justify-content:space-between; align-items:center;">
          <div>
            <span style="color:${this.getActionColor(log.action)}; font-weight:700;">${log.action}</span>
            <span style="color:var(--text-muted); font-size:0.75rem; margin-left:6px;">(${log.performedByRole})</span>
          </div>
          <span style="color:var(--text-dim); font-size:0.75rem;">${log.timestamp.includes('T') ? log.timestamp.split('T')[1]?.slice(0, 8) : log.timestamp}</span>
        </div>
      `
      )
      .join('');
  }

  private getActionColor(action: string): string {
    if (action.includes('SESSION_CREATED') || action.includes('CONNECTED')) return '#10b981';
    if (action.includes('FAILED') || action.includes('ENDED')) return '#ef4444';
    if (action.includes('AID') || action.includes('COMMAND')) return '#f59e0b';
    return '#3b82f6';
  }

  public mount(container: HTMLElement): void {
    container.innerHTML = '';
    container.appendChild(this.element);
  }
}
